<template>
  <div id="app">
    <n-loading-bar :loading="loading"></n-loading-bar>
    <h1>AI小助手</h1>
    <div class="box" @click="onAIClick">
      <div class="box-bg"></div>
      <div class="box-content">立即开始</div>
    </div>
  </div>
</template>

<script>
import { startChat } from '@/components/aiChat'
import store from '@/store';

export default {
  name: 'App',
  computed: {
    loading () {
      return store.state.loading
    }
  },
  methods: {
    onAIClick () {
      return startChat({room_title: '帮助对话'})
    }
  }
}
</script>

<style lang="scss" scoped>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #fff;
  padding: 100px 40px;
}
h1 {
  color: #181818;
  font-size: 44px;
  line-height: 64px;
  font-weight: 600;
}
.box {
  margin-top: 40px;
  width: 263px;
  height: 52px;
  cursor: pointer;
  position: relative;
  background-image: linear-gradient(253deg, #7366FF 0%, #1366EC 100%);
  &-bg,
  &-content {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }
  &-bg {
    opacity: 0;
    transition: opacity 0.3s ease-out;
    background-image: linear-gradient(253deg, #6340FF 0%, #1154C0 100%);
  }
  &-content {
    color: #fff;
    height: 52px;
    font-size: 14px;
    font-weight: 500;
    line-height: 52px;
    box-sizing: border-box;
    padding: 0 24px;
    &:before {
      position: absolute;
      right: 24px;
      top: 25.5px;
      content: " ";
      width: 10px;
      border-top: 1px solid #fff;
      transition: right .3s ease-out;
    }
    &:after {
      position: absolute;
      right: 24px;
      top: 23px;
      content: " ";
      width: 6px;
      height: 6px;
      border: 1px solid #fff;
      border-width: 1px 1px 0 0;
      transform: rotate(45deg);
      transition: right .3s ease-out;
    }
  }
  &:hover &-bg {
    opacity: 1;
  }
  &:hover &-content:before,
  &:hover &-content:after {
    right: 16px;
  }
}
</style>
